const Sentry = require("@sentry/browser");

Sentry.init({
  dsn: 'https://3811f53d101a49c9b3c802c9cc068e7b@sentry.infoware.de//4',
  tracesSampleRate: 1.0,
});
